export const sortByProp = (elements: any[], prop: string, type: 'asc' | 'desc' = 'asc') => {
    return [...elements].sort((a, b) => {
        const comparison = a[prop] < b[prop] ? -1 : a[prop] > b[prop] ? 1 : 0;
        return type === 'asc' ? comparison : -comparison;
    });
};
